"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section, Accordion } from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsAccordion() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Accordion
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            A vertically stacked set of interactive headings that each reveal a section of content.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/accordion" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>A basic accordion with multiple items</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <Accordion
            items={[
              { id: "1", title: "Is it accessible?", content: "Yes. It adheres to the WAI-ARIA design pattern." },
              { id: "2", title: "Is it styled?", content: "Yes. It comes with default styles that match the design system." },
              { id: "3", title: "Is it animated?", content: "Yes. It's animated by default with smooth height transitions." },
            ]}
          />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Default</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">items</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">AccordionItem[]</td>
                <td className="py-2 font-mono text-xs">required</td>
                <td className="py-2 text-muted-foreground">Array of accordion items</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">defaultOpen</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 font-mono text-xs">-</td>
                <td className="py-2 text-muted-foreground">ID of initially open item</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">allowMultiple</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">boolean</td>
                <td className="py-2 font-mono text-xs">false</td>
                <td className="py-2 text-muted-foreground">Allow multiple items open</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
